import { render, staticRenderFns } from "./SurveysInstancesTable.vue?vue&type=template&id=d889ad72&scoped=true"
import script from "./SurveysInstancesTable.vue?vue&type=script&lang=js"
export * from "./SurveysInstancesTable.vue?vue&type=script&lang=js"
import style0 from "./SurveysInstancesTable.vue?vue&type=style&index=0&id=d889ad72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d889ad72",
  null
  
)

export default component.exports